import { get, post, postJson } from '../axios'

/***
* 根据会员体系ID查询详情
*/
export const getDetailById = p => post(`/members-api/scoresCard/getDetailById`, p)

/***
* 保存/编辑会员体系
*/
export const saveScoresCard = p => postJson(`/members-api/scoresCard`, p)

/***
* 查询全部店铺列表
*/
export const scoresBindList = p => get(`/members-api/bindAuthController/scoresBindList`, p)

/***
* 查询已关联的店铺列表
*/
export const isScoresBindList = p => post(`/members-api/scoresCard/shop/list`, p)

/***
* 查询基础积分标准
*/
export const benchmarkDetail = p => post(`/members-api/scoresCard/rule/detail`, p)

/***
* 修改基础积分标准
*/
export const benchmarkUpdate = p => postJson(`/members-api/scoresCard/rule/update`, p)

/***
* 查询积分(奖励/屏蔽)规则列表
*/
export const rewardRuleList = p => postJson(`/members-api/scoresCard/rewardRule/list`, p)

/***
* 删除积分(奖励/屏蔽)规则
*/
export const rewardRuleDelete = p => post(`/members-api/scoresCard/rewardRule/delete`, p)

/***
* 开启关闭积分(奖励/屏蔽)规则
*/
export const rewardRuleUpdateStatus = p => post(`/members-api/scoresCard/rewardRule/updateStatus`, p)

/***
* 查询积分奖励/屏蔽规则详情
*/
export const rewardRuleDetail = p => post(`/members-api/scoresCard/rewardRule/detail`, p)
/***
* 保存积分奖励/屏蔽规则
*/
export const rewardRuleSave = p => postJson(`/members-api/scoresCard/rewardRule/save`, p)

/***
* 查询积分扣减规则
*/
export const RuleDeductDetail = p => post(`/members-api/scoresCard/rule/deduct`, p)

/***
* 保存积分扣减规则
*/
export const RuleDeductSave = p => postJson(`/members-api/scoresCard/rule/deduct/save`, p)

/***
* 查询订单详情
*/
export const getOrderListReq = p => postJson(`/members-api/yunque/getTradeInfoList`, p)
